
document.addEventListener("DOMContentLoaded", function () {
  const fuseCategories = [
    // Universal
    { term: "Pet Food", url: "/collections/pet-food" },
    { term: "Food", url: "/collections/pet-food" },
    { term: "Pill Givers", url: "/collections/pill-givers" },
    { term: "Prescription Food", url: "/collections/prescription-food" },
    { term: "Pet First Aid & Recovery", url: "/collections/pet-first-aid-recovery" },
    { term: "Pet First Aid", url: "/collections/pet-first-aid-recovery" },
    { term: "Pet Recovery", url: "/collections/pet-first-aid-recovery" },
    { term: "First Aid & Recovery", url: "/collections/pet-first-aid-recovery" },
    { term: "First Aid", url: "/collections/pet-first-aid-recovery" },
    { term: "Recovery", url: "/collections/pet-first-aid-recovery" },
    { term: "Pet Shampoo & Conditioners", url: "/collections/pet-shampoo-conditioner" },
    { term: "Pet Shampoo", url: "/collections/pet-shampoo-conditioner" },
    { term: "Pet Conditioners", url: "/collections/pet-shampoo-conditioner" },
    { term: "Shampoo & Conditioners", url: "/collections/pet-shampoo-conditioner" },
    { term: "Shampoo", url: "/collections/pet-shampoo-conditioner" },
    { term: "Conditioners", url: "/collections/pet-shampoo-conditioner" },
    { term: "Pet Vitamins & Supplements", url: "/collections/pet-vitamins-supplements" },
    { term: "Pet Vitamins", url: "/collections/pet-vitamins-supplements" },
    { term: "Pet Supplements", url: "/collections/pet-vitamins-supplements" },
    { term: "Vitamins & Supplements", url: "/collections/pet-vitamins-supplements" },
    { term: "Vitamins", url: "/collections/pet-vitamins-supplements" },
    { term: "Supplements", url: "/collections/pet-vitamins-supplements" },
    { term: "Pet Apparel", url: "/collections/pet-apparel" },
    { term: "Pet Clothing", url: "/collections/pet-apparel" },
    { term: "Pet Outfits", url: "/collections/pet-apparel" },
    { term: "Apparel", url: "/collections/pet-apparel" },
    { term: "Clothing", url: "/collections/pet-apparel" },
    { term: "Outfits", url: "/collections/pet-apparel" },
    { term: "Pet Treats", url: "/collections/pet-treats" },
    { term: "Treats", url: "/collections/pet-treats" },
    { term: "Pet Toys", url: "/collections/pet-toys" },
    { term: "Toys", url: "/collections/pet-toys" },
    { term: "Pet Healthcare", url: "/collections/pet-healthcare" },
    { term: "Healthcare", url: "/collections/pet-healthcare" },
    { term: "Pet Accessories", url: "/collections/pet-accessories" },
    { term: "Accessories", url: "/collections/pet-accessories" },
    { term: "Pet Conditions", url: "/collections/pet-conditions" },
    { term: "Conditions", url: "/collections/pet-conditions" },

    
    { term: "Offers", url: "/collections/sale" },
    { term: "Deals", url: "/collections/sale" },
    { term: "Repeat & Save", url: "/collections/repeat-save" },
    { term: "Repeat", url: "/collections/repeat-save" },
    { term: "Subscription", url: "/collections/repeat-save" },
    { term: "Vet's Favourite", url: "/collections/vets-favourite" },
    { term: "Veterinary Favourite", url: "/collections/vets-favourite" },
    { term: "Vet Approved", url: "/collections/vets-favourite" },
    { term: "Veterinary Approved", url: "/collections/vets-favourite" },

    
    { term: "Dog", url: "/collections/dog" },
    { term: "Cat", url: "/collections/cats" },


    // Dog Food
    { term: "Dog Food", url: "/collections/dog-food" },
    { term: "Dry Dog Food", url: "/collections/dry-dog-food" },
    { term: "Wet Dog Food", url: "/collections/wet-dog-food" },
    { term: "Prescription Dog Food", url: "/collections/prescription-dog-food" },
    { term: "Dog Treats", url: "/collections/dog-treats" },
    { term: "Hypoallergenic Dog Food", url: "/collections/hypoallergenic-dog-food" },
    { term: "Grain-Free Dog Food", url: "/collections/grain-free-dog-food" },
    { term: "Senior Dog Food", url: "/collections/senior-dog-food" },
    //
    // Dog Healthcare
    { term: "Dog Healthcare", url: "/collections/dog-healthcare" },
    { term: "Dog Vitamins & Supplements", url: "/collections/dogs-vitamin-supplements" },
    { term: "Dog Vitamins", url: "/collections/dogs-vitamin-supplements" },
    { term: "Dog Supplements", url: "/collections/dogs-vitamin-supplements" },
    { term: "Dog Prescriptions", url: "/collections/dog-prescriptions" },
    { term: "Dog Flea & Tick", url: "/collections/dog-flea-and-tick-control" },
    { term: "Dog Wormer", url: "/collections/dog-flea-and-tick-control" },
    { term: "Dog Dental Care", url: "/collections/dog-dental-care" },
    { term: "Dog Shampoo & Conditioners", url: "/collections/dog-shampoo-conditioners" },
    { term: "Dog Shampoo", url: "/collections/dog-shampoo-conditioners" },
    { term: "Dog Conditioners", url: "/collections/dog-shampoo-conditioners" },
    { term: "Dog First Aid", url: "/collections/dogs-first-aid" },
    { term: "Dog Recovery", url: "/collections/dogs-first-aid" },
    { term: "Dog Hairball", url: "/collections/dogs-hairball-laxative-remedies" },
    { term: "Dog Laxative", url: "/collections/dogs-hairball-laxative-remedies" },
    //
    // Dog Accessories
    { term: "Dog Accessories", url: "/collections/dog-accessories" },
    { term: "Dog Bowls", url: "/collections/dog-bowls-feeders-and-waterers" },
    { term: "Dog Feeders", url: "/collections/dog-bowls-feeders-and-waterers" },
    { term: "Dog Combs & Brushes", url: "/collections/combs-brushes" },
    { term: "Dog Combs", url: "/collections/combs-brushes" },
    { term: "Dog Brushes", url: "/collections/combs-brushes" },
    { term: "Dog Collars & Leads", url: "/collections/dog-collars-leads" },
    { term: "Dog Collars", url: "/collections/dog-collars-leads" },
    { term: "Dog Leads", url: "/collections/dog-collars-leads" },
    { term: "Dog Toys", url: "/collections/dog-toys" },
    { term: "Dog Beds", url: "/collections/dog-beds" },
    { term: "Dog Odour & Stain", url: "/collections/dog-odour-stain-remover" },
    { term: "Dog Odour & Stain Remover", url: "/collections/dog-odour-stain-remover" },
    { term: "Dog Stain Remover", url: "/collections/dog-odour-stain-remover" },
    { term: "Dog Deterrent", url: "/collections/dog-deterrent-repellents" },
    { term: "Dog Repellents", url: "/collections/dog-deterrent-repellents" },
    { term: "Dog Apparel", url: "/collections/dog-apparel" },
    { term: "Dog Clothing", url: "/collections/dog-apparel" },
    { term: "Dog Outfits", url: "/collections/dog-apparel" },
    //
    // Dog Conditions
    { term: "Dog Conditions", url: "/collections/dog-conditions" },
    { term: "Dog Allergy & Skin", url: "/collections/dog-allergy-skin-care" },
    { term: "Dog Allergy", url: "/collections/dog-allergy-skin-care" },
    { term: "Dog Anxiety & Calmers", url: "/collections/dog-anxiety-calmers" },
    { term: "Dog Anxiety", url: "/collections/dog-anxiety-calmers" },
    { term: "Dog Calmers", url: "/collections/dog-anxiety-calmers" },
    { term: "Diabetic Dog", url: "/collections/diabetic-dog-care" },
    { term: "Dog Digestive", url: "/collections/digestive-care-for-dogs" },
    { term: "Dog Ear Health", url: "/collections/ear-health-products-for-dogs" },
    { term: "Dog Ear", url: "/collections/ear-health-products-for-dogs" },
    { term: "Dog Eye Health", url: "/collections/eye-health-products-for-dogs" },
    { term: "Dog Eye", url: "/collections/eye-health-products-for-dogs" },
    { term: "Dog Joint Care", url: "/collections/joint-mobility-for-dogs" },
    { term: "Dog Joint", url: "/collections/joint-mobility-for-dogs" },
    { term: "Dog Mobility", url: "/collections/joint-mobility-for-dogs" },
    { term: "Dog Joint & Mobility", url: "/collections/joint-mobility-for-dogs" },
    { term: "Dog Liver Health", url: "/collections/liver-health-products-for-dogs" },
    { term: "Dog Liver Care", url: "/collections/liver-health-products-for-dogs" },
    { term: "Dog Liver", url: "/collections/liver-health-products-for-dogs" },
    { term: "Dog Kidney Health", url: "/collections/kidney-health-products-for-dogs" },
    { term: "Dog Kidney Care", url: "/collections/kidney-health-products-for-dogs" },
    { term: "Dog Urinary & Bladder", url: "/collections/dogs-urinary-bladderdogs-urinary-bladder" },
    { term: "Dog Bladder", url: "/collections/dogs-urinary-bladderdogs-urinary-bladder" },
    //
    // Puppy
    { term: "Puppy", url: "/collections/puppy-products" },
    { term: "Puppy Food", url: "/collections/puppy-food" },
    { term: "Wet Puppy Food", url: "/collections/wet-puppy-food" },
    { term: "Dry Puppy Food", url: "/collections/dry-puppy-food" },
    { term: "Puppy Toys", url: "/collections/puppy-toys" },
    { term: "Puppy Grooming", url: "/collections/puppy-grooming-supplies" },

    // Cat Food
    { term: "Cat Food", url: "/collections/cat-food" },
    { term: "Dry Cat Food", url: "/collections/dry-cat-food" },
    { term: "Wet Cat Food", url: "/collections/wet-cat-food" },
    { term: "Prescription Cat Food", url: "/collections/prescription-cat-food" },
    { term: "Cat Treats", url: "/collections/cat-treats" },
    { term: "Hypoallergenic Cat Food", url: "/collections/hypoallergenic-cat-food" },
    { term: "Grain-Free Cat Food", url: "/collections/grain-free-cat-food" },
    { term: "Senior Cat Food", url: "/collections/senior-cat-food" },
    //
    // Cat Healthcare
    { term: "Cat Healthcare", url: "/collections/cat-healthcare" },
    { term: "Cat Vitamins & Supplements", url: "/collections/cats-vitamin-supplements" },
    { term: "Cat Vitamins", url: "/collections/cats-vitamin-supplements" },
    { term: "Cat Supplements", url: "/collections/cats-vitamin-supplements" },
    { term: "Cat Prescriptions", url: "/collections/cat-prescriptions" },
    { term: "Cat Flea & Tick", url: "/collections/cat-flea-and-tick-control" },
    { term: "Cat Wormer", url: "/collections/cat-flea-and-tick-control" },
    { term: "Cat Dental Care", url: "/collections/cat-dental-care" },
    { term: "Cat Shampoo & Conditioners", url: "/collections/cat-shampoo-conditioners" },
    { term: "Cat Shampoo", url: "/collections/cat-shampoo-conditioners" },
    { term: "Cat Conditioners", url: "/collections/cat-shampoo-conditioners" },
    { term: "Cat First Aid", url: "/collections/cats-first-aid" },
    { term: "Cat Recovery", url: "/collections/cats-first-aid" },
    { term: "Cat Hairball", url: "/collections/cats-hairball-laxative-remedies" },
    { term: "Cat Laxative", url: "/collections/cats-hairball-laxative-remedies" },
    //
    // Cat Accessories
    { term: "Cat Accessories", url: "/collections/cat-accessories" },
    { term: "Cat Litter", url: "/collections/cat-litter" },
    { term: "Cat Toys", url: "/collections/cat-toys" },
    { term: "Catnip", url: "/collections/catnip" },
    { term: "Cat Combs & Brushes", url: "/collections/combs-brushes" },
    { term: "Cat Combs", url: "/collections/combs-brushes" },
    { term: "Cat Brushes", url: "/collections/combs-brushes" },
    { term: "Cat Bowls", url: "/collections/cat-bowls" },
    { term: "Cat Feeders", url: "/collections/cat-bowls" },
    { term: "Cat Beds & Furniture", url: "/collections/cat-beds-furniture" },
    { term: "Cat Beds", url: "/collections/cat-beds-furniture" },
    { term: "Cat Furniture", url: "/collections/cat-beds-furniture" },
    { term: "Cat Collars & Harnesses", url: "/collections/cat-collars-and-harnesses" },
    { term: "Cat Collars", url: "/collections/cat-collars-and-harnesses" },
    { term: "Cat Harnesses", url: "/collections/cat-collars-and-harnesses" },
    { term: "Cat Carriers & Crates", url: "/collections/cat-carriers-and-crates" },
    { term: "Cat Carriers", url: "/collections/cat-carriers-and-crates" },
    { term: "Cat Crates", url: "/collections/cat-carriers-and-crates" },
    { term: "Cat Odour & Stain Remover", url: "/collections/cat-odour-stain-remover" },
    { term: "Cat Odour", url: "/collections/cat-odour-stain-remover" },
    { term: "Cat Stain Remover", url: "/collections/cat-odour-stain-remover" },
    { term: "Cat Deterrent & Repellents", url: "/collections/cat-deterrent-repellents" },
    { term: "Cat Deterrent", url: "/collections/cat-deterrent-repellents" },
    { term: "Cat Repellents", url: "/collections/cat-deterrent-repellents" },
    { term: "Cat Apparel", url: "/collections/cat-apparel" },
    { term: "Cat Clothing", url: "/collections/cat-apparel" },
    { term: "Cat Outfits", url: "/collections/cat-apparel" },
    //
    // Cat Conditions
    { term: "Cat Conditions", url: "/collections/cat-conditions" },
    { term: "Cat Allergy & Skin", url: "/collections/cat-allergy-skin-care" },
    { term: "Cat Allergy", url: "/collections/cat-allergy-skin-care" },
    { term: "Cat Anxiety & Calmers", url: "/collections/cat-anxiety-calmers" },
    { term: "Cat Anxiety", url: "/collections/cat-anxiety-calmers" },
    { term: "Cat Calmers", url: "/collections/cat-anxiety-calmers" },
    { term: "Diabetic Cat", url: "/collections/diabetic-cat-care" },
    { term: "Digestive Cat", url: "/collections/digestive-care-for-cats" },
    { term: "Cat Ear", url: "/collections/ear-health-products-for-cats" },
    { term: "Cat Eye", url: "/collections/eye-health-products-for-cats" },
    { term: "Cat Joint & Mobility", url: "/collections/joint-mobility-for-cats" },
    { term: "Cat Joint", url: "/collections/joint-mobility-for-cats" },
    { term: "Cat Mobility", url: "/collections/joint-mobility-for-cats" },
    { term: "Cat Liver", url: "/collections/liver-health-products-for-cats" },
    { term: "Cat Kidney", url: "/collections/kidney-health-products-for-cats" },
    { term: "Cat Urinary", url: "/collections/cats-urinary-bladder" },
    { term: "Cat Bladder", url: "/collections/cats-urinary-bladder" },
    //
    // Kitten
    { term: "Kitten", url: "/collections/kitten-products" },
    { term: "Kitten Food", url: "/collections/kitten-food" },
    { term: "Wet Kitten Food", url: "/collections/wet-kitten-food" },
    { term: "Dry Kitten Food", url: "/collections/dry-kitten-food" },
    { term: "Kitten Toys", url: "/collections/kitten-toys" },
    { term: "Kitten Treats", url: "/collections/kitten-treats" },
    { term: "Kitten Grooming", url: "/collections/kitten-grooming-supplies" },

    // Brands
    { term: "Hill's", url: "/collections/hills" },
    { term: "Ceva", url: "/collections/ceva" },
    { term: "Protexin", url: "/collections/protexin" },
    { term: "Trixie", url: "/collections/trixie" },
    { term: "Kong", url: "/collections/kong" },
    { term: "Lintbells", url: "/collections/lintbells" },
    { term: "YuMOVE", url: "/collections/lintbells" },
    { term: "Purina", url: "/collections/purina" },
    { term: "Pro Plan", url: "/collections/purina" },
    { term: "Virbac", url: "/collections/virbac" },
    { term: "Vetoquinol", url: "/collections/vetoquinol" },
    { term: "Royal Canin", url: "/collections/royal-canin" },
    
    // Prescription
    { term: "Pain Relief", url: "/collections/prescriptions?filter.p.product_type=Pain+%26+Anti-inflammatory" },
    { term: "Anti-inflammatory", url: "/collections/prescriptions?filter.p.product_type=Pain+%26+Anti-inflammatory" },
    { term: "Hormonal", url: "/collections/prescriptions?filter.p.product_type=Hormonal+Support" },
    { term: "Hormone", url: "/collections/prescriptions?filter.p.product_type=Hormonal+Support" },
    { term: "Hormone Medicine", url: "/collections/prescriptions?filter.p.product_type=Hormonal+Support" },
    { term: "Allergy Treatments", url: "/collections/prescriptions?filter.p.product_type=Allergy+Treatments" },
    { term: "Allergy Medicine", url: "/collections/prescriptions?filter.p.product_type=Allergy+Treatments" },
    { term: "Prescriptions", url: "/collections/prescriptions" }
  ];

  const fuseFilterOmit = [
    "pet",
    "pets",
    "product",
    "products",
    "care",
    "supplies",
    "support",
    "control",
    "health"
  ];

  const fuseWords = [
    "A-Ball",
    "A-Partz",
    "AKTIVAIT",
    "APRYLIC",
    "ATOP",
    "Acana",
    "Aceponate",
    "Action",
    "Active",
    "Activity",
    "Adaptil",
    "Add",
    "Added",
    "Additional",
    "Additive",
    "Adenovirus",
    "Adhesive",
    "Adt",
    "Adult",
    "Adults",
    "Advance",
    "Advanced",
    "Advantage",
    "Ageing",
    "Agility",
    "Aid",
    "Aids",
    "AirDog",
    "All",
    "Allerderm",
    "Allermyl",
    "Alligator",
    "American",
    "Amodip",
    "Anal",
    "Ancient",
    "Ancol",
    "And",
    "Animal",
    "Animals",
    "Anti",
    "Antiseptic",
    "Anxiety",
    "Anxitane",
    "Apoquel",
    "Apple",
    "Aqua",
    "Aquadent",
    "Asbrip",
    "Aspergillus",
    "Assorted",
    "Atopica",
    "AvoCATo",
    "Away",
    "BUNDLE",
    "BUSTER",
    "Babycat",
    "Babydog",
    "Backseat",
    "Bag",
    "Bags",
    "Bake",
    "Balance",
    "Ball",
    "Ballistic",
    "Balloon",
    "Balls",
    "Balm",
    "Bamboo",
    "Bandage",
    "Barnyard",
    "Barrier",
    "Bars",
    "Based",
    "Basic",
    "Baskerville",
    "Basket",
    "Bat",
    "Bayer",
    "Bear",
    "Beaver",
    "Beco",
    "Bed",
    "Bedding",
    "Bedtime",
    "Bee",
    "Beef",
    "Belly",
    "Belt",
    "Bench",
    "Benefit",
    "Berlin",
    "Best",
    "Better",
    "Big",
    "Binkie",
    "Bio",
    "Biome",
    "Bionic",
    "Biotic",
    "Biotin",
    "Bird",
    "Birds",
    "Birthday",
    "Biscuit",
    "Biscuits",
    "Bisolvon",
    "Bites",
    "Bitter",
    "Black",
    "Blade",
    "Blood",
    "Blue",
    "Blue/Beige",
    "Blueberry",
    "Boa",
    "Boar",
    "Board",
    "Bobz",
    "Body",
    "Bone",
    "Bones",
    "Boost",
    "Booster",
    "Boot",
    "Boots",
    "Bottle",
    "Bountiful",
    "Bounzer",
    "Bowl",
    "Bowls",
    "Box",
    "Boy",
    "Brain",
    "Brands",
    "Breaker",
    "Breakfast",
    "Breaktime",
    "Breed",
    "Brights",
    "Bristle",
    "Broccoli",
    "Broth",
    "Brown",
    "Brush",
    "Bugalugs",
    "Bundle",
    "Bungalow",
    "Bunji",
    "Bunny",
    "Burgers",
    "Burrito",
    "Buster",
    "Butter",
    "ButterSquash",
    "Butterfly",
    "Butternut",
    "Buzz",
    "Buzzy",
    "CANIN",
    "CATBana",
    "CET",
    "CLX",
    "CONTINENCE",
    "Cactus",
    "Calibrated",
    "Calicivirus",
    "Calm",
    "Calming",
    "Calorie",
    "Campfire",
    "Campylobacter",
    "Can",
    "Canidryl",
    "Canine",
    "Caninsulin",
    "Caniphedrin",
    "Canned",
    "Cans",
    "Capsules",
    "CarSafe",
    "Card",
    "Care",
    "Carnival",
    "Carprieve",
    "Carprodyl",
    "Carprox",
    "Carrier",
    "Carrot",
    "Carry",
    "Cartridges",
    "Casper",
    "Casserole",
    "Cat",
    "Catch",
    "Caterpillar",
    "Caticorn",
    "Catit",
    "Catmosphere",
    "Catnip",
    "Catrine",
    "Cats",
    "Catsan",
    "Catwalk",
    "Cerenia",
    "Chameleon",
    "Chappie",
    "Characters",
    "Chateau",
    "Cheese",
    "Cheetah",
    "Chew",
    "ChewStix",
    "Chewable",
    "Chews",
    "Chick",
    "Chicken",
    "Chill",
    "Chillz",
    "Chirpz",
    "Chlamydia",
    "Chomp",
    "Chonks",
    "Cigar",
    "Cimalgex",
    "Ckn",
    "Classic",
    "Classics",
    "Clean",
    "Cleaner",
    "Cleaning",
    "Cleanser",
    "Cleansing",
    "Clear",
    "Clic",
    "Clicker",
    "Clikka",
    "Clinical",
    "Clippers",
    "Clomicalm",
    "Clorexyderm",
    "Clostridial",
    "Cloud",
    "Coa",
    "Coachi",
    "Coarse",
    "Coast",
    "Coat",
    "Coated",
    "Coats",
    "Cobalaplex",
    "Coccidia",
    "Cod",
    "Coli",
    "Collapsible",
    "Collar",
    "Collection",
    "Colours",
    "Comb",
    "Comber",
    "Combi",
    "Comet",
    "Comfort",
    "Compact",
    "Complete",
    "Concentrated",
    "Confetti",
    "Connects",
    "Consult",
    "Control",
    "Cooked",
    "Cooling",
    "Coprostop",
    "CoreStrength",
    "Corestrength",
    "Cork",
    "Corneal",
    "Cortavance",
    "Cortisol",
    "Cottage",
    "Cotton",
    "Cough",
    "Count",
    "Countryside",
    "Cover",
    "Cozie",
    "Crab",
    "Crackerjacks",
    "Cracking",
    "Crackle",
    "Crackles",
    "Cradle",
    "Cranberry",
    "Creatinine",
    "Critter",
    "Cross",
    "Crunch",
    "CrunchAir",
    "Cruncheez",
    "Cryptosporidia",
    "Cube",
    "Cuddler",
    "Cuisine",
    "Culture",
    "Curlz",
    "Cushion",
    "Cutaneous",
    "CuteSeas",
    "Cuts",
    "Cystease",
    "CystoPro",
    "Cystophan",
    "D-C",
    "DIETS",
    "DLH",
    "DOUXO",
    "DSH",
    "Daily",
    "Danish",
    "Dasuquin",
    "Dechra",
    "Defence",
    "Deluxe",
    "Demodex",
    "Denamarin",
    "Dent",
    "Dental",
    "Dentihex",
    "Derm",
    "Dermacomfort",
    "DermalEase",
    "Dermanolon",
    "Dermatophyte",
    "Dermoscent",
    "Design",
    "Dexacortone",
    "Diabetes",
    "Diabetic",
    "Diarrohoea",
    "Diet",
    "Diffuser",
    "Digestion",
    "Digestive",
    "Dinner",
    "Dipstick",
    "Disc",
    "Disinfectant",
    "Dispenser",
    "Dispensing",
    "Disposable",
    "Document",
    "Dog",
    "Dogs",
    "Donkey",
    "Donut",
    "Dorwest",
    "Dotz",
    "Double",
    "Douxo",
    "Dragon",
    "Dreamies",
    "Dried",
    "Droncit",
    "Dronspot",
    "Drontal",
    "Drops",
    "Dry",
    "Dual",
    "Duck",
    "Dumbbell",
    "Dummy",
    "Duo",
    "Duramax",
    "Dynos",
    "ELISA",
    "Ear",
    "Eared",
    "Early",
    "EaseFlex",
    "Easy",
    "EasyPill",
    "Eaze",
    "Educ",
    "Effipro",
    "Egg",
    "Electrophoresis",
    "Elephant",
    "Emeprid",
    "Enchanted",
    "Ended",
    "Endogard",
    "Energy",
    "English",
    "Enterogenic",
    "Entr",
    "Enurace",
    "Enzorb",
    "Enzymatic",
    "Enzyme",
    "Eon",
    "Epi-Otic",
    "Ergo",
    "Ermidra",
    "Essential",
    "Ever",
    "Examination",
    "Exigent",
    "Expert",
    "Extra",
    "Extreme",
    "Eye",
    "F10",
    "F10SC",
    "FELIWAY",
    "FRONTLINE",
    "FRONTPRO",
    "Face",
    "Faeces",
    "Famous",
    "Fat",
    "Favourites",
    "Feast",
    "Feather",
    "Fed",
    "Feeder",
    "Feeding",
    "Felimazole",
    "Feline",
    "Feline/Canine",
    "Feliway",
    "Fetch",
    "FetchStix",
    "Fibre",
    "File",
    "Fillets",
    "Film",
    "Fine",
    "Finger",
    "Finilac",
    "Finz",
    "First",
    "Fish",
    "Fisherman's",
    "Fishy",
    "Fit",
    "Flamingo",
    "Flavour",
    "Flavoured",
    "Flavours",
    "Flea",
    "Flexball",
    "Flingaroo",
    "Flip",
    "Floofs",
    "Floppy",
    "Flops",
    "Flopzie",
    "Fluid",
    "Flutterz",
    "Flyer",
    "Foam",
    "Foetus",
    "Fold",
    "Folding",
    "Food",
    "Football",
    "For",
    "Forthyron",
    "FortiFlora",
    "Fox",
    "Fr3sh",
    "Frazzle",
    "Free",
    "Freeze",
    "Friends",
    "Frizzle",
    "Frog",
    "Front",
    "Fun",
    "Function",
    "Furr",
    "Furry",
    "Galastop",
    "Galliprant",
    "Game",
    "Garden",
    "Gastro",
    "Gastrointestinal",
    "Gatoi",
    "Gecko",
    "Gel",
    "General",
    "Geodz",
    "Germicidal",
    "Giant",
    "Giardia",
    "Gift",
    "Giraffe",
    "Giver",
    "Gland",
    "Glandex",
    "Glorious",
    "Glove",
    "Gnashers",
    "Gold",
    "Goodie",
    "Goomz",
    "Goulash",
    "Grain",
    "Grains",
    "Grannick's",
    "Granules",
    "Grass",
    "Grasslands",
    "Gravity",
    "Gravy",
    "Green",
    "Grey",
    "Groom",
    "Grooming",
    "Gun",
    "Gut",
    "Gyro",
    "H20",
    "H2O",
    "Hair",
    "Hairball",
    "Hairballs/Furballs",
    "Halo",
    "Halti",
    "Hammock",
    "HandiPOD",
    "Handle",
    "Happy",
    "Hard",
    "Harness",
    "Harvest",
    "Headcollar",
    "Health",
    "Healthy",
    "Heat",
    "HedgeHug",
    "Help",
    "Henry",
    "Hepatic",
    "Hepaticare",
    "Heritage",
    "Herpesvirus",
    "Hexarinse",
    "Hibiwash",
    "Hide",
    "Hideaway",
    "High",
    "Highest",
    "Hiking",
    "Hill",
    "Hill's",
    "Hills",
    "Hind",
    "Hole",
    "Home",
    "HomeoPet",
    "Homeopathic",
    "Homestead",
    "Honkers",
    "Horn",
    "Hotpot",
    "Hound",
    "Hula",
    "Hummingbird",
    "Hydra",
    "Hydration",
    "Hydrocortisone",
    "Hygiene",
    "Hygienic",
    "HypoAllergenic",
    "Hypoallergenic",
    "In-One",
    "IncrediBowl",
    "Incurin",
    "Indoor",
    "Indorex",
    "Inflacam",
    "Inflatable",
    "Infused",
    "Infuser",
    "Injection",
    "Injuries",
    "Innovations",
    "Insulated",
    "Insulin",
    "Interactive",
    "Interchangeable",
    "Intestinal",
    "Itching",
    "Jack",
    "James",
    "Jaxx",
    "Jelly",
    "Jerky",
    "Johnson's",
    "Joii",
    "Joint",
    "JointWell",
    "Jolly",
    "Jumbler",
    "Jumbo",
    "Jump",
    "Junior",
    "KONG",
    "Kalm",
    "KarmaWrap",
    "Katalax",
    "Khaki",
    "Kibble",
    "Kickeroo",
    "Kickeroos",
    "Kiddos",
    "Kidney",
    "Kit",
    "Kitchen",
    "Kitten",
    "Kittens",
    "Kitty",
    "Knee",
    "Knife",
    "Knobby",
    "Knot",
    "Knots",
    "Koala",
    "Kolin",
    "Kradle",
    "Krunchies",
    "Kruuse",
    "Kumfy",
    "L-Lysine",
    "LYPEX",
    "Lab",
    "Ladybug",
    "Lamb",
    "Large",
    "Larvae",
    "Laser",
    "Launcher",
    "Laxapet",
    "Laxatract",
    "Lead",
    "Lean",
    "Legs",
    "Legz",
    "Leishmania",
    "Leucillin",
    "Leventa",
    "Librela",
    "Lick'n'",
    "LickiMat",
    "Licks",
    "Life",
    "Light",
    "Lightweight",
    "Lily's",
    "Line",
    "Liquid",
    "Litter",
    "Little",
    "Liver",
    "Llama",
    "Llamas",
    "Loaf",
    "Lock",
    "Logic",
    "Long",
    "Low",
    "Loxicom",
    "Lube",
    "Lubricating",
    "Lubrithal",
    "Lung",
    "Luv",
    "MDC",
    "MPS",
    "Machine",
    "Maintenance",
    "Malaseb",
    "Mallard",
    "Malt",
    "Management",
    "Mango",
    "Marvin",
    "Master",
    "Mat",
    "Matt",
    "Matts",
    "Mature",
    "Max",
    "Maxi",
    "Maxx",
    "Maze",
    "Mealtime",
    "Meat",
    "Meaty",
    "Medical",
    "Medium",
    "Medrone",
    "Mega",
    "Meloxidyl",
    "Memory",
    "Meowee",
    "Metabolic",
    "Metacam",
    "Meticillin",
    "Microscopy",
    "Microwavable",
    "Mighty",
    "Mikki",
    "Milk",
    "Min",
    "Mini",
    "Miniature",
    "Minijacks",
    "Mirataz",
    "Mix",
    "Mixed",
    "Mobile",
    "Mobility",
    "Moderate",
    "Moggy",
    "Moose",
    "Mother",
    "Mothering",
    "Moult",
    "Moulting",
    "Mouse",
    "Mousse",
    "Multi",
    "MultiVits",
    "Multicare",
    "Multipack",
    "Munchies",
    "Mussel",
    "Mutt",
    "Muzzle",
    "Mycoplasma",
    "Nail",
    "Natural",
    "Naturals",
    "Navy",
    "Needles",
    "Neurocare",
    "Neutered",
    "Nextmune",
    "Nibble",
    "Nibbles",
    "Niblets",
    "Nights",
    "Nina",
    "Nippers",
    "Non",
    "Noys",
    "Nursing",
    "Nutri",
    "Nutrition",
    "Nylon",
    "ON-CARE",
    "ON-Care",
    "Occasions",
    "Occult",
    "Ocean",
    "Ocry-Gel",
    "Ocryl",
    "Octopus",
    "Odour",
    "Off",
    "Ogee",
    "Oil",
    "Ointment",
    "Old",
    "On-Care",
    "On-the-Go",
    "One",
    "One-A-Day",
    "One-a-day",
    "Onsior",
    "Onychotin",
    "Ophthalmic",
    "OptiFit",
    "Optimmune",
    "Optimum",
    "Optixcare",
    "Oral",
    "Oralade",
    "Orange",
    "Orbitz",
    "Organic",
    "Original",
    "Orthopaedic",
    "Oto",
    "Otoact",
    "Otoclean",
    "Otodex",
    "Otodine",
    "Otoprof",
    "Ottosson",
    "Out",
    "Outward",
    "Over",
    "Owl",
    "PCR",
    "PDQ",
    "PLAN",
    "PLUS",
    "PRO",
    "PURINA",
    "PYOclean",
    "Pacifica",
    "Pack",
    "Package",
    "Pad",
    "Pads",
    "Panacur",
    "Pancreatic",
    "Panel",
    "Panleucopaenia",
    "Pants",
    "Panzym",
    "Papaya",
    "Parasite",
    "Pardale-V",
    "Party",
    "Parvovirus",
    "Paste",
    "Pastels",
    "Pat",
    "Pate",
    "Paw",
    "Paws",
    "Pea",
    "Peanut",
    "Peas",
    "Peptivet",
    "Perfect",
    "Perfringens",
    "Pet",
    "PetGear",
    "Petface",
    "Petkin",
    "Petlife",
    "Petrol",
    "Pets",
    "Phatz",
    "Pie",
    "Pig",
    "Pill",
    "Pillow",
    "Pin",
    "Ping",
    "Pink",
    "Pippettes",
    "Plan",
    "Plant",
    "Plaque",
    "Plastic",
    "Play",
    "PlaySpaces",
    "Playdate",
    "Plus",
    "Plush",
    "Pocket",
    "Pocketz",
    "Pointer",
    "Pong",
    "Pooch",
    "Poop",
    "Porcupine",
    "Pork",
    "Porus",
    "Post",
    "Potato",
    "Pouches",
    "Poultry",
    "Powder",
    "Power",
    "Powered",
    "Poxvirus",
    "Prairie",
    "Prednicare",
    "Prednicortone",
    "Prednidale",
    "Prednisolone",
    "Premium",
    "Prescription",
    "Previcox",
    "Pro",
    "ProZinc",
    "Probiotic",
    "Products",
    "Professional",
    "Pronefra",
    "Propalin",
    "Protector",
    "Protectorband",
    "Protein",
    "Protexin",
    "Pull",
    "Pumpkin",
    "Pup",
    "Puppies",
    "Puppy",
    "Purple",
    "Purrsuit",
    "Puzzle",
    "Puzzlements",
    "Pyo",
    "Quadri",
    "Quest",
    "Quickfit",
    "RECOVA",
    "ROYAL",
    "Rabbits",
    "Radiator",
    "Rainbow",
    "Rake",
    "Ramp",
    "Ranchlands",
    "Range",
    "Ratio",
    "Razzle",
    "Recipe",
    "Recipes",
    "Reconcile",
    "Recovery",
    "Red",
    "Reducing",
    "Reduction",
    "Reefz",
    "Refill",
    "Refillable",
    "Refillables",
    "Refills",
    "Reflective",
    "Reflex",
    "Rehab",
    "Rehydrating",
    "Relaxed",
    "Remedy",
    "Remend",
    "Removal",
    "Remover",
    "Renal",
    "Replacement",
    "Resistant",
    "Respiratory",
    "Response",
    "Reward",
    "Rewards",
    "Rheumocam",
    "Ribbon",
    "Rice",
    "Rimadyl",
    "Ring",
    "Ringworm",
    "Robexera",
    "Roll",
    "Roller",
    "Rope",
    "Rosewood",
    "Rottweiler",
    "Rubber",
    "Run",
    "Rycarfa",
    "S/O",
    "Sachet",
    "Sachets",
    "Safestix",
    "Safety",
    "Salmon",
    "Salmonella",
    "Satiety",
    "Saucer",
    "Sausages",
    "Savour",
    "Scalibor",
    "Scavenge",
    "Science",
    "Scissors",
    "Scoopz",
    "Scratch",
    "Scratch/Lick/Bite",
    "Scratcher",
    "Scratching",
    "Scrattles",
    "Screen",
    "Scruffs",
    "Scrumbles",
    "Scrumptious",
    "Scrunch",
    "Sea",
    "Seagull",
    "Seat",
    "Seb",
    "Sebo",
    "Second",
    "Sediment",
    "Select",
    "Selection",
    "Self",
    "Selgian",
    "Senior",
    "Senses",
    "Sensitive",
    "Sensitivities",
    "Sensitivity",
    "Sensory",
    "Senvelgo",
    "Seresto",
    "Set",
    "Shakers",
    "Shampoo",
    "Shedding",
    "Sheep",
    "Shell",
    "Shells",
    "Shepherd's",
    "Sherps",
    "Shieldz",
    "Shimmy",
    "Shirt",
    "Shop",
    "Short",
    "Shredded",
    "Shrimps",
    "Sided",
    "Signature",
    "Silicone",
    "Silvervine",
    "Simple",
    "Simply",
    "Single",
    "Singles",
    "Skin",
    "Skunk",
    "Sleeve",
    "Slender",
    "Slicker",
    "Slim",
    "Slip",
    "Sloth",
    "Slow",
    "Small",
    "Smart",
    "Smooth",
    "Snack",
    "Snacks",
    "Sneakerz",
    "Snoozer",
    "Snowy",
    "Snugga",
    "Snuggle",
    "Snugglesafe",
    "Snuzzles",
    "Soccer",
    "Soft",
    "SoftE",
    "SoftSeas",
    "Softening",
    "Softies",
    "Softseas",
    "Sole",
    "Soluble",
    "Solution",
    "Solutions",
    "Spaces",
    "Spare",
    "Special",
    "Specific",
    "Speckles",
    "Spider",
    "Spin",
    "Spinner",
    "Spiral",
    "Splitter",
    "Sport",
    "Sports",
    "Spot",
    "Spot-On",
    "Spray",
    "Sprays",
    "Sprinkle",
    "Sprinkler",
    "Squash",
    "Squeakair",
    "Squeaker",
    "Squeakers",
    "Squeezz",
    "Squiggles",
    "Stages",
    "Stain",
    "Stainless",
    "Staphylococci",
    "Star",
    "Starfish",
    "Starry",
    "Starter",
    "Steel",
    "Stellar",
    "Sterilised",
    "Stew",
    "Stick",
    "Stickaroo",
    "Sticks",
    "Stomach",
    "Stomodine",
    "Stop",
    "Storage",
    "Strategy",
    "Strength",
    "Stress",
    "Stretchezz",
    "Stripping",
    "Stroke",
    "Strong",
    "Stuff",
    "Stuff'n",
    "Styles",
    "Styptic",
    "Suit",
    "Superfood",
    "Supper",
    "Suppers",
    "Supplement",
    "Support",
    "Surosolve",
    "Sushi",
    "Suspension",
    "Swabs",
    "Swedencare",
    "Sweet",
    "Switcheroos",
    "Swizzle",
    "Synbiotic",
    "Syringe",
    "Syrup",
    "Tablets",
    "TagAlong",
    "Tagine",
    "Tangle",
    "Tape",
    "Tapewormer",
    "Tasty",
    "Teaser",
    "Teddy",
    "Teething",
    "Tennis",
    "Tennishoes",
    "Terrine",
    "Test",
    "Tests",
    "Tether",
    "The",
    "Thiafeline",
    "Thiamacare",
    "ThunderShirt",
    "Thyforon",
    "Thyroid",
    "Thyronorm",
    "Tick",
    "Tiger",
    "Tinker",
    "Tins",
    "Tone",
    "Toothbrush",
    "Toothpaste",
    "Top",
    "Toxins",
    "Toy",
    "Toys",
    "Training",
    "Transport",
    "Travel",
    "Trays",
    "Treat",
    "Treatment",
    "Treats",
    "Trial",
    "Trichogram",
    "Triple",
    "Tritrichomonas",
    "Trixie",
    "Trocoxil",
    "Tropics",
    "Tub",
    "Tube",
    "Tuck",
    "Tug",
    "TuggerKnots",
    "Tuggz",
    "Tuna",
    "Turkey",
    "Tutu",
    "Tweezerz",
    "Twists",
    "Twistz",
    "Two",
    "Tyre",
    "U/C",
    "Ultimate",
    "Ultra",
    "Undercoat",
    "Unicorn",
    "Urinalysis",
    "Urinary",
    "Urine",
    "VETERINARY",
    "Variety",
    "Veg",
    "Vegan",
    "Vegetable",
    "Vegetables",
    "Veggie",
    "VeggieDent",
    "Venison",
    "Vet",
    "Vet's",
    "VetIQ",
    "VetPen",
    "Vetbed",
    "Vetericyn",
    "Veterinary",
    "Vetoryl",
    "Vetpen",
    "Viacutan",
    "Vibez",
    "Vibrant",
    "Vidalta",
    "Virbac",
    "Virus",
    "Vis",
    "Vitality",
    "Wag",
    "Walk",
    "Walka",
    "Walking",
    "Walkrite",
    "Wally",
    "Wash",
    "Water",
    "Waterproof",
    "Wavz",
    "Wax",
    "Weaves",
    "Web",
    "Weekend",
    "Weight",
    "Wellbeloved",
    "Wet",
    "Whale",
    "Whirlwind",
    "Whistle",
    "White",
    "Wholesome",
    "Wicker",
    "Wiggi",
    "Wild",
    "Winders",
    "Window",
    "Winkz",
    "Wipes",
    "With",
    "Wobbler",
    "Wood",
    "Wooden",
    "Woodland",
    "Woofbrush",
    "Woozles",
    "Working",
    "Worm",
    "Wormer",
    "Wormscreen",
    "Wound",
    "Wounds",
    "Wrangler",
    "Wubba",
    "Yarnimals",
    "Yellow",
    "Yersinia",
    "Yorkshire",
    "Young",
    "Ypozane",
    "YuCARE",
    "YuMOVE",
    "YuMove",
    "Zazzle",
    "Zincoseb",
    "Zitac",
    "Zoom",
    "Zurich",
    "Zylkene",
    "add",
    "and",
    "b/d",
    "breed",
    "breeds",
    "c/d",
    "called",
    "cat",
    "cats",
    "chewable",
    "comprehensive",
    "d/d",
    "dogs",
    "for",
    "formerly",
    "i/d",
    "individual",
    "j/d",
    "k/d",
    "known",
    "l/d",
    "m/d",
    "makeup",
    "mg/ml",
    "microgram/ml",
    "mixed",
    "oral",
    "pack",
    "pets",
    "profile",
    "pure",
    "qPCR",
    "r/d",
    "s/d",
    "solution",
    "speciation",
    "syrup",
    "t/d",
    "tablets",
    "test",
    "the",
    "thrive",
    "u/d",
    "under",
    "w/d",
    "with",
    "y/d",
    "z/d"
  ];


  var open_icon = `
    <svg class="search-res-open-icon" width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
      <path d="M17 7H7M7 7V17M7 7L17 17" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    </svg>
  `;

  var icon_right = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M10 7L15 12L10 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `;

  var icon_query = ``;
  var icon_product = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 32 32">
      <g fill="none" fill-rule="evenodd">
        <path d="m0 0h32v32h-32z"/>
        <path d="m19 1.73205081 7.8564065 4.53589838c1.8564064 1.07179677 3 3.05255889 3 5.19615241v9.0717968c0 2.1435935-1.1435936 4.1243556-3 5.1961524l-7.8564065 4.5358984c-1.8564065 1.0717968-4.1435935 1.0717968-6 0l-7.85640646-4.5358984c-1.85640646-1.0717968-3-3.0525589-3-5.1961524v-9.0717968c0-2.14359352 1.14359354-4.12435564 3-5.19615241l7.85640646-4.53589838c1.8564065-1.07179677 4.1435935-1.07179677 6 0zm4.0203166 9.82532719c-.259282-.4876385-.8647807-.672758-1.3524192-.4134761l-5.6794125 3.0187491-5.6793299-3.0187491c-.4876385-.2592819-1.09313718-.0741624-1.35241917.4134761-.25928198.4876385-.07416246 1.0931371.41347603 1.3524191l5.61827304 2.9868539.0000413 6.7689186c0 .5522848.4477153 1 1 1 .5522848 0 1-.4477152 1-1l-.0000413-6.7689186 5.6183556-2.9868539c.4876385-.259282.6727581-.8647806.4134761-1.3524191z" fill="currentColor"/>
      </g>
    </svg>
  `;
  var icon_category = `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-768.000000, -144.000000)">
              <g transform="translate(768.000000, 144.000000)">
                  <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" fill-rule="nonzero"></path>
                  <path d="M19,11 C20.0543909,11 20.9181678,11.81585 20.9945144,12.8507339 L21,13 L21,19 C21,20.0543909 20.18415,20.9181678 19.1492661,20.9945144 L19,21 L15,21 C13.9456091,21 13.0818322,20.18415 13.0054856,19.1492661 L13,19 L13,13 C13,11.9456091 13.81585,11.0818322 14.8507339,11.0054856 L15,11 L19,11 Z M9,15 C10.1046,15 11,15.8954 11,17 L11,19 C11,20.1046 10.1046,21 9,21 L5,21 C3.89543,21 3,20.1046 3,19 L3,17 C3,15.8954 3.89543,15 5,15 L9,15 Z M9,3 C10.1046,3 11,3.89543 11,5 L11,11 C11,12.1046 10.1046,13 9,13 L5,13 C3.89543,13 3,12.1046 3,11 L3,5 C3,3.89543 3.89543,3 5,3 L9,3 Z M19,3 C20.1046,3 21,3.89543 21,5 L21,7 C21,8.10457 20.1046,9 19,9 L15,9 C13.8954,9 13,8.10457 13,7 L13,5 C13,3.89543 13.8954,3 15,3 L19,3 Z" fill="currentColor"></path>
              </g>
          </g>
      </g>
    </svg>
  `;
  var icon_article = `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-624.000000, -48.000000)">
                <g  transform="translate(624.000000, 48.000000)">
                    <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" fill-rule="nonzero"></path>
                    <path d="M14.1121,3.74436 L21.5556,7.50517 C22.2205,7.84112 22.5196,8.59793 22.3192,9.28014 C21.9281,10.6114 21.9721,11.1694 22.2271,11.8013 C22.4843,12.439 22.3056,13.25 21.6396,13.6717 L11.3564,20.181 C10.9248,20.4542 10.376,20.4962 9.89935,20.263 L6.05902772,18.3681074 L6.05902772,18.3681074 L4.45466861,17.5631024 L4.45466861,17.5631024 L3.3147029,16.9807486 L3.3147029,16.9807486 L2.61935644,16.6161315 L2.61935644,16.6161315 L2.25891498,16.4203332 L2.25891498,16.4203332 L1.99784,16.2704 L1.99784,16.2704 C0.978593,15.6551 0.661234,14.4053 0.665723311,13.4489 C0.670479,12.4776 1.00406,11.2651 1.93052,10.5984 L2.23122413,10.3919735 L2.23122413,10.3919735 L3.08869037,9.83087121 L3.08869037,9.83087121 L5.13397057,8.52495179 L5.13397057,8.52495179 L12.6424,3.81015 L12.6424,3.81015 C13.0889,3.53153 13.6458,3.50879 14.1121,3.74436 Z M20.0332,10.6884 L11.3601,16.1786 L11.252425,16.2406125 L11.141,16.2931 C11.031,16.7007 10.9926,16.9942 10.9966,17.2663 C10.999075,17.42845 11.0164563,17.5940313 11.0522453,17.7827453 L11.0943,17.9799 L20.2418,12.1895 L20.1697231,11.9414463 C20.0838602,11.6116648 20.0387231,11.2844907 20.0315269,10.945287 L20.0332,10.6884 Z M2.79954,12.6779 C2.7221,12.8834 2.66729,13.1469 2.66573667,13.4585 C2.66258,14.1302 2.9033,14.4809 3.03144,14.5582 L3.33878481,14.7327827 L3.33878481,14.7327827 L3.96509578,15.0660297 L3.96509578,15.0660297 L5.73461671,15.96917 L5.73461671,15.96917 L9.01149,17.5987 L9.01149,17.5987 C9.00334,17.4983 8.99838,17.3976 8.99686,17.2961 C8.99134,16.92586 9.0315608,16.563108 9.11095344,16.1834216 L9.17774,15.8951 L2.79954,12.6779 Z M13.964,6.91416 C13.4747,6.6579 12.8704,6.84676 12.6141,7.33599 C12.3761071,7.790275 12.5219857,8.34381301 12.9357207,8.6257562 L13.0359,8.68583 L15.1359,9.78583 C15.6252,10.0421 16.2295,9.85323 16.4858,9.364 C16.7237,8.909715 16.577901,8.35617699 16.1641779,8.0742338 L16.064,8.01416 L13.964,6.91416 Z" fill="currentColor"></path>
                </g>
            </g>
        </g>
    </svg>
  `;
  var icon_page = ``;
  var icon_blog = ``;

  var fuseCategorically;
  var fuseTypos;

  const SEARCH_MODE = "json";
  // "json" | "section"


  // backup retry filter if no results
  const NOISE_WORDS = new Set([
    "best",
    "top",
    "cheap",
    "good",
    "premium",
    "high",
    "quality",
    "buy",
    "purchase"
  ]);

  function cleanQuery(q) {
    return q
      .toLowerCase()
      .split(/\s+/)
      .filter(w => !NOISE_WORDS.has(w))
      .join(" ")
      .trim();
  }

  function buildQueryAttempts(q) {
    const cleaned = cleanQuery(q);
    const tokens = cleaned.split(/\s+/).filter(Boolean);

    const attempts = [];

    // 1. cleaned full query first
    if (cleaned) attempts.push(cleaned);

    // 2. progressive reduction from START
    for (let i = 1; i < tokens.length; i++) {
      attempts.push(tokens.slice(i).join(" "));
    }

    // 3. final fallback
    if (tokens.length) attempts.push(tokens[tokens.length - 1]);

    return [...new Set(attempts)];
  }


  function setSearchPopupOpen(isOpen) {
    const body = document.body;
    const popup = document.querySelector(".joii-search-popup");

    // history.pushState(
    //   { searchDrawerOpen: true },
    //   "",
    //   window.location.href
    // );
    // if (!history.state?.searchDrawerOpen) {
    //   history.pushState({ searchDrawerOpen: true }, "", location.href);
    // }

    if (isOpen) {
      history.pushState(
        { searchDrawerOpen: true },
        "",
        window.location.href
      );
      window.scrollTo(0, 0);
      body.classList.add("search-scroll-lock");
      popup.style.display = 'grid';
      
    } else {
      body.classList.remove("search-scroll-lock");
      popup.style.display = 'none';
    }
  }
  window.addEventListener("popstate", (e) => {
    const popup = document.querySelector('.joii-search-popup');
    if (popup && popup.innerHTML.trim() !== "") {
      popup.style.display = 'none';
      setSearchPopupOpen(false);
    }
  });

  async function fetchSearchData(searchTerm, signal) {
    const mode = SEARCH_MODE || "json";
    const attempts = buildQueryAttempts(searchTerm);

    for (const attempt of attempts) {
      try {
        const result = await fetchOnce(attempt, mode, signal);

        if (hasAnyResults(result)) {
          return {
            ...result,
            usedQuery: attempt,
            empty: false
          };
        }
      } catch (e) {
        // ignore and continue
      }
    }

    return fallbackEmpty(mode, searchTerm);
  }

  async function fetchOnce(searchTerm, mode, signal) {
    if (mode === "section") {
      const url = `/search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=joii-predictive-search`;

      const res = await fetch(url, { signal });
      if (!res.ok) throw new Error("Section search failed");

      return {
        mode: "section",
        html: await res.text()
      };
    }

    var searchType = `page,article`;
    if (window.shopping == true) {
      var searchType = `product,collection,page,article,query`;
    }

    var url = `/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=${searchType}&resources[limit]=10&resources[limit_scope]=each`;
    

    const res = await fetch(url, { signal });
    if (!res.ok) throw new Error("Predictive search failed");

    return {
      mode: "json",
      data: await res.json()
    };
  }

  function hasAnyResults(result) {
    if (!result) return false;

    if (result.mode === "section") {
      return result.html && result.html.trim().length > 50; // heuristic
    }

    const r = result?.data?.resources?.results;
    if (!r) return false;

    return (
      (r.products?.length || 0) +
      (r.collections?.length || 0) +
      (r.pages?.length || 0) +
      (r.articles?.length || 0) +
      (r.queries?.length || 0)
    ) > 0;
  }

  function fuseSearch(query) {
    //console.log("fuse");
    var useQuery = query;
    let termLower = query.toLowerCase();

    // Filter out omit words (but keep original query intact)
    fuseFilterOmit.forEach(word => {
      if (termLower.includes(word) && !(word === "health" && termLower.includes("healthcare"))) {
        // Remove the word from the query
        const regex = new RegExp(`\\b${word}\\b`, 'gi');
        useQuery = useQuery.replace(regex, '').trim();
      }
    });

    // fuse match
    const categoricalResults = fuseCategorically.search(useQuery);
    if (categoricalResults.length && categoricalResults[0].score < 0.4) {
      const best = categoricalResults[0].item;
      window.location.href = best.url;
    } else {
      const wordResults = fuseTypos.search(useQuery);
      
      const words = useQuery.split(/\s+/);
      const correctedWords = [];
      let correctionMade = false;
      words.forEach(word => {
        const typoMatch = fuseTypos.search(word);
        if (typoMatch.length && typoMatch[0].score < 0.4) {
          correctedWords.push(typoMatch[0].item); // Suggested correction
          if (typoMatch[0].item.toLowerCase() !== word.toLowerCase()) {
            correctionMade = true;
          }
        } else {
          correctedWords.push(word); // Keep original
        }
      });

      const fallbackURL = `/search?type=product,collection&q=${encodeURIComponent(query)}`;
      if (correctionMade) {
        const correctedQuery = correctedWords.join(' ');
        window.location.href = `${fallbackURL}&dym=${encodeURIComponent(correctedQuery)}`;
      } else {
        window.location.href = fallbackURL;
      }
    }
  }

  function renderPredictive(data, container, searchTerm) {
    const results = data.resources.results;

    container.innerHTML = "";

    const wrap = document.createElement("div");
    wrap.className = "joii-search-popup";

    // --- Suggestions ---
    const sugg = document.createElement("div");
    sugg.className = "joii-search-suggestions";

    const addLink = (item, cls, label) => {
      const a = document.createElement("a");
      a.href = item.url;
      a.className = `search-suggestion ${cls}`;
      a.innerHTML = `<span>${item.text || item.title}</span>`;
      sugg.appendChild(a);
    };

    results.queries.forEach(i => addLink(i, "query_sugg"));
    results.collections.forEach(i => addLink(i, "category_sugg"));
    results.pages.forEach(i => addLink(i, "page_sugg"));
    results.articles.forEach(i => addLink(i, "article_sugg"));

    wrap.appendChild(sugg);

    // --- Products ---
    if (results.products?.length) {
      const products = document.createElement("div");
      products.className = "joii-search-products";

      results.products.slice(0, 9).forEach(p => {
        const a = document.createElement("a");
        a.href = p.url;
        a.className = "joii-search-product";

        const img = document.createElement("img");
        img.src = p.image;
        img.alt = p.title;

        const title = document.createElement("div");
        title.className = "search-product-title";
        title.textContent = p.title;

        const price = document.createElement("div");
        price.className = "search-product-price";
        price.textContent = Shopify.formatMoney(p.price);

        const info = document.createElement("div");
        info.className = "search-product-info";
        info.append(title, price);

        const imgWrap = document.createElement("div");
        imgWrap.className = "search-product-image";
        imgWrap.appendChild(img);

        a.append(imgWrap, info);
        products.appendChild(a);
      });

      wrap.appendChild(products);
    }

    // --- View all ---
    const total =
      results.products.length +
      results.collections.length +
      results.pages.length +
      results.articles.length;

    const viewAll = document.createElement("a");
    viewAll.className = "search-view-all";
    viewAll.href = `/search?q=${encodeURIComponent(searchTerm)}&type=product,collection,page,article`;
    viewAll.textContent = `View all ${total} items`;

    wrap.appendChild(viewAll);

    container.appendChild(wrap);
  }

  function fallbackEmpty(mode, searchTerm = "") {
    if (mode === "section") {
      return {
        mode: "section",
        html: `
          <div class="search-empty" style="display: flex; flex-direction: column;">
            <span>No results found for "<strong>${searchTerm}</strong>"</span>
          </div>
        `
      };
    }

    return {
      mode: "json",
      data: {
        resources: {
          results: {
            products: [],
            collections: [],
            pages: [],
            articles: [],
            queries: []
          }
        }
      },
      usedQuery: searchTerm,
      empty: true
    };
  }


  function renderSearchProducts(predictive) {
    let html = "";

    if (!predictive.products) return html;

    if (predictive.products.length) {
      html += `<div class="joii-search-products">`;
      //html += `<pre>${JSON.stringify(predictive.products, null, 2)}</pre>`;

      const blocked = ["hidden-from-search", "unlisted"];

      const filteredProducts = predictive.products
        .filter(product => {
          const tags = Array.isArray(product.tags)
            ? product.tags
            : (product.tags || "").split(",");

          return !tags.some(tag =>
            blocked.includes(String(tag).trim().toLowerCase())
          );
        }); // FILTER FIRST

      filteredProducts
        .slice(0, 9) // SLICE AFTER
        .forEach(product => {

          const title = product.title || "";
          const vendor = product.vendor || "";

          const titleLower = title.toLowerCase();
          const vendorLower = vendor.toLowerCase();

          let displayTitle = title;

          if (vendor && titleLower.includes(vendorLower)) {
            const regex = new RegExp(vendor, "gi");
            displayTitle = title.replace(
              regex,
              `<strong>${vendor}</strong>`
            );
          }

          const price = product.price;
          const compareAt = product.compare_at_price;

          const money = (v) => Shopify.formatMoney(v);

          let priceHtml = "";

          if (compareAt && compareAt > price) {
            priceHtml = `
              <span class="price-item actual-price">
                ${money(price)}
              </span>
              <span class="price-item compare-price" style="text-decoration: line-through; opacity: 0.6;">
                ${money(compareAt)}
              </span>
            `;
          }

          else if (
            product.price_min &&
            product.price_max &&
            product.price_min !== product.price_max
          ) {
            priceHtml = `
              <span class="price-item actual-price price-varies">
                ${money(product.price_min)} – ${money(product.price_max)}
              </span>
            `;
          }

          else {
            priceHtml = `
              <span class="price-item actual-price">
                ${money(price)}
              </span>
            `;
          }

          html += `
            <a href="${product.url}" class="joii-search-product joii-product-card-item">
              <div class="search-product-image product-card-img">
              <div class="product-img">
                <div class="media">
                  <img class="product-image" src="${product.image}" alt="${title}"/>
                </div>
              </div>
              </div>

              <div class="search-product-info joii-product-card-detail">
                <div class="search-product-title product-title">
                  ${displayTitle}
                </div>

                <div class="search-product-price product-price">
                  ${priceHtml}
                </div>
              </div>
            </a>
          `;
        });

      html += `</div>`;
    }

    return html;
  }


  //search drawer js
  var searchTyping;


  let activeSearchController = null;

  var __searchResult = function(searchTerm, searchparent) {
    if (!searchparent || !searchTerm) return;

    hideOtherMegaMenus();

    //console.log("__searchResult");

    let resultContainer = searchparent.querySelector("[data-result-container]");
    let suggestionContainer = searchparent.querySelector("[data-suggestions-container]");
    let searchDrawer = searchparent.querySelector("[data-search-drawer]");
    let predictiveWrapper = searchparent.querySelector(".joii-predictive-search");

    if (!resultContainer) return;

    let drawer = resultContainer.closest("[data-search-drawer]");
    let headerStyle = drawer?.getAttribute("data-header");
    let suggestionStatus = drawer?.getAttribute("data-suggestionStatus");

    if (searchTerm.replace(/\s/g, "").length > 0) {

      if (predictiveWrapper) predictiveWrapper.classList.remove("hidden");
      if (drawer) drawer.classList.remove("hidden");

      if (
        headerStyle == "logo_with_search_bar" &&
        suggestionStatus == "false"
      ) {
        drawer.classList.remove("hidden");
      }

      if (suggestionContainer) {
        //suggestionContainer.classList.add("hidden");
      }

      //resultContainer.classList.remove("hidden");
      resultContainer.innerHTML = preLoadLoadGif;

      if (activeSearchController) {
        activeSearchController.abort();
      }

      activeSearchController = new AbortController();

      resultContainer.innerHTML = preLoadLoadGif;

      fetchSearchData(searchTerm, activeSearchController.signal)
        .then((response) => {

          if (response.mode === "section") {
            resultContainer.innerHTML = response.html;
            return;
          }

          const predictive = response.data.resources.results;

          const isEmpty =
            response.empty ||
            (
              (predictive.products?.length ?? 0) === 0 &&
              (predictive.collections?.length ?? 0) === 0 &&
              (predictive.pages?.length ?? 0) === 0 &&
              (predictive.articles?.length ?? 0) === 0 &&
              (predictive.queries?.length ?? 0) === 0
            );

          if (isEmpty) {
            resultContainer.innerHTML = `
              <div class="joii-search-popup search-empty-state" style="padding: 15px; display: flex; flex-direction: column;">
                <p>No results found for "<strong>${searchTerm}</strong>"</p>
                <a href="/search?q=${encodeURIComponent(searchTerm)}">
                  View full search results
                </a>
              </div>
            `;
            return;
          }

          const results = response.data?.resources?.results || {};

          const totalResults =
            (results.products?.length ?? 0) +
            (results.collections?.length ?? 0) +
            (results.pages?.length ?? 0) +
            (results.articles?.length ?? 0) +
            (results.queries?.length ?? 0);

          let increaseLimit = 0;
          if (totalResults < 20) increaseLimit = 2;
          if (totalResults < 15) increaseLimit = 3;

          const normalizeSearch = (str = "") =>
            String(str)
              .toLowerCase()
              .replace(/®/g, "")
              .replace(/'/g, "")
              .replace(/&/g, "and")
              .replace(/\s+/g, " ")
              .trim();

          const collectionUrlMap = new Map();

          if (predictive.collections) {
            predictive.collections.forEach(col => {
              collectionUrlMap.set(
                normalizeSearch(col.title || col.handle || col.url),
                col.url
              );
            });
          }

          const getBrandUrl = (brand, pos = 1) => {
            const key = normalizeSearch(brand.name);

            const collectionUrl = collectionUrlMap.get(key);

            // 1. If Shopify already gave us a predictive collection URL, trust it
            if (collectionUrl) return collectionUrl;

            // 2. Otherwise construct using ONLY observed Shopify-style params
            const params = new URLSearchParams({
              _pos: pos,
              _psq: searchTerm,
              _ss: "e",
              _v: "1.0"
            });

            return `${brand.url}?${params.toString()}`;
          };

          const normalizedTerm = normalizeSearch(searchTerm);

          const normalizeUrl = (url = "") =>
            url.split("?")[0].replace(/\/$/, "");

          // -----------------------------
          // MATCHING BRANDS (ALL TOGETHER)
          // -----------------------------
          const matchingBrands = (window.brands ?? []).filter(brand => {
            const name = normalizeSearch(brand.name);

            const alt =
              !brand.alt || brand.alt === "null"
                ? ""
                : normalizeSearch(brand.alt);

            return (
              name.includes(normalizedTerm) ||
              alt.includes(normalizedTerm)
            );
          });

          // -----------------------------
          // OPTIONAL QUERY CLEANUP ONLY
          // (NO BRAND PRIORITISATION)
          // -----------------------------
          const topSuggestion = predictive.queries?.[0];

          const topSuggestionNormalized = normalizeSearch(
            topSuggestion?.text || ""
          );

          const filteredQueries = predictive.queries.filter(item => {
            return normalizeSearch(item.text) !== topSuggestionNormalized;
          });
          let html = ``;
          //html += `<pre>${JSON.stringify(predictive.collections, null, 2)}</pre>`;
          //html += `<span>${totalResults}</span>`
          html += `<div class="joii-search-popup">`;

          html += `<div class="joii-search-suggestions">`;

          //html += `<span style="display: none !important;">${JSON.stringify(response, null, 2)}</span>`;
          let shopping = window.shopping;
          let brands_pos = "";

          console.log(window.shopping);
          console.log(shopping);

          if (shopping) {
            if (!matchingBrands.length) {
              // hide
            } else if (matchingBrands.length > 1) {
              brands_pos = "group";
            } else {
              brands_pos = "group";
              if (normalizeSearch(predictive.queries?.[0]?.text) && normalizeSearch(matchingBrands?.[0]?.name)) {
                if (normalizeSearch(predictive.queries?.[0]?.text || "") === normalizeSearch(matchingBrands?.[0]?.name || "")) {
                  brands_pos = "match";
                } else {
                  brands_pos = "group";
                }
              }
            }

            if (brands_pos === "match") {
              matchingBrands.forEach(brand => {
                html += `
                  <a href="${getBrandUrl(brand)}" class="search-suggestion brand_sugg shop-more-by-brand">
                    <img height="40" width="40" src="${brand.logo}"/>
                    <span>Shop All ${brand.name}</span>
                    ${icon_right}
                  </a>
                `;
              });
            }
          }

          // -----------------------------
          // QUERIES
          // -----------------------------
          if (filteredQueries.length) {
            html += `<span class="sugg_title">Popular Suggestions</span>`;
          }

          filteredQueries.slice(0, 6 + increaseLimit).forEach(item => {
            html += `
              <a href="${item.url}" class="search-suggestion query_sugg">
                ${icon_query}
                <span>${item.text}</span>
                ${open_icon}
              </a>
            `;
          });

          if (shopping) {
            // -----------------------------
            // BRANDS (ALL TOGETHER)
            // -----------------------------
            if (brands_pos === "group") {
              html += `<span class="sugg_title">Brands</span>`;
              matchingBrands.slice(0, 4 + increaseLimit).forEach(brand => {
                html += `
                  <a href="${getBrandUrl(brand)}" class="search-suggestion brand_sugg shop-more-by-brand">
                    <img height="40" width="40" src="${brand.logo}"/>
                    <span>Shop All ${brand.name}</span>
                    ${icon_right}
                  </a>
                `;
              });
            }
          }


          if (shopping) {
            // -----------------------------
            // COLLECTIONS
            // -----------------------------
            const brandUrls = new Set(
              matchingBrands.map(b => normalizeUrl(b.url))
            );
            const filteredCollections = predictive.collections.filter(col =>
              !brandUrls.has(normalizeUrl(col.url))
            );

            if (filteredCollections.length) {
              html += `<span class="sugg_title">Collections</span>`;
            }

            filteredCollections.slice(0, 3 + increaseLimit).forEach(item => {
              html += `
                <a href="${item.url}" class="search-suggestion category_sugg">
                  ${icon_category}
                  <span>${item.title}</span>
                  ${open_icon}
                </a>
              `;
            });
          }

          // -----------------------------
          // PAGES
          // -----------------------------
          const blockedWords = ["terms"];

          const filteredPages = predictive.pages.filter(item => {
            const title = (item.title || "").toLowerCase();

            return !blockedWords.some(word => title.includes(word));
          });

          if (filteredPages.length) {
            html += `<span class="sugg_title">Pages</span>`;
          }

          filteredPages.slice(0, 3 + increaseLimit).forEach(item => {
            html += `
              <a href="${item.url}" class="search-suggestion page-sugg">
                ${icon_page}
                <span>${item.title}</span>
                ${open_icon}
              </a>
            `;
          });

          // -----------------------------
          // ARTICLES
          // -----------------------------
          if (predictive.articles.length) {
            html += `<span class="sugg_title">Learn from our vets</span>`;
          }

          predictive.articles.slice(0, 3 + increaseLimit).forEach(item => {
            html += `
              <a href="${item.url}" class="search-suggestion article_sugg">
                ${icon_article}
                <span>${item.title}</span>
                ${open_icon}
              </a>
            `;
          });


          const total =
            (predictive?.products?.length ?? 0) +
            (predictive?.collections?.length ?? 0) +
            (predictive?.pages?.length ?? 0) +
            (predictive?.articles?.length ?? 0);

          // html += `
          //   <div class="search-view-all">
          //     <a href="/search?q=${encodeURIComponent(searchTerm)}&type=product,collection,page,article">
          //       View all ${total} items
          //     </a>
          //   </div>
          // `;
          html += `
            <div class="search-view-all desktop-btn">
              <a href="/search?q=${encodeURIComponent(searchTerm)}&type=product">
                View all
              </a>
            </div>
          `;


          html += `</div>`;

          // -----------------------------
          // PRODUCTS
          // -----------------------------
          html += renderSearchProducts(predictive);

          html += `
            <div class="search-view-all mobile-btn">
              <a href="/search?q=${encodeURIComponent(searchTerm)}&type=product">
                View all
              </a>
            </div>
          `;

          html += `</div>`;



          resultContainer.innerHTML = html;

          if (predictiveWrapper) predictiveWrapper.classList.remove("hidden");
          if (drawer) drawer.classList.remove("hidden");
          if (suggestionContainer) suggestionContainer.classList.remove("hidden");
          resultContainer.classList.remove("hidden");

          disableNavHover();

          setSearchPopupOpen(true);
        })
        .catch(err => {
          if (err.name !== "AbortError") {
            console.error(err);
          }
        });

    } else {

      // 🔥 FIX: re-hide everything consistently
      //if (predictiveWrapper) predictiveWrapper.classList.add("hidden");
      //if (drawer) drawer.classList.add("hidden");

      if (suggestionContainer) {
        //suggestionContainer.classList.remove("hidden");
      }

      if (
        headerStyle == "logo_with_search_bar" &&
        suggestionStatus == "false"
      ) {
        //drawer?.classList.add("hidden");
      }

      //resultContainer.classList.add("hidden");
      resultContainer.innerHTML = "";
    }
  };

  function initSpeectRecognition(searchSpeech) {
      let speechRecognition = null;
      let listening = false;
      let searchInput = null;
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (
          "webkitSpeechRecognition" in window &&
          userAgent.indexOf("chrome") > -1 &&
          !!window.chrome &&
          userAgent.indexOf("edg/") === -1
      ) {
          searchSpeech.classList.remove("hidden");
          speechRecognition = new window.webkitSpeechRecognition();
          speechRecognition.continuous = false;
          speechRecognition.interimResults = false;
          searchInput = searchSpeech
              .closest("form")
              .querySelector("[joii-data-search-input]");
          speechRecognition.addEventListener(
              "result",
              debounce((evt) => {
                  if (evt.results) {
                      const term = evt.results[0][0].transcript;
                      searchInput.value = term;
                      searchInput.focus();
                      searchInput.dispatchEvent(new Event("input"));
                      let searchparent = searchInput.closest("[joii-data-search-parent]");
                      __searchResult(term, searchparent);
                  }
              }, 300)
          );

          speechRecognition.addEventListener("audiostart", () => {
              listening = true;
              searchSpeech.classList.add("active");
          });

          speechRecognition.addEventListener("audioend", () => {
              listening = false;
              searchSpeech.classList.remove("active");
          });

          searchSpeech.addEventListener("click", function(evt) {
              evt.preventDefault();
              if (listening) {
                  speechRecognition.stop();
                  listening = false;
              } else {
                  speechRecognition.start();
                  listening = true;
              }
          });

          searchSpeech.addEventListener("keydown", (evt) => {
              if (evt.code === "Space" || evt.code === "Enter") {
                  evt.preventDefault();
                  if (listening) {
                      speechRecognition.stop();
                  } else {
                      speechRecognition.start();
                  }
              }
          });
      }
  }

  function search_drawer_tab() {
    //console.log("search_drawer_tab");
      let elements = document.querySelectorAll(".predictive-tab-item");
      if (elements) {
          Array.from(elements).forEach(function(element) {
              setTimeout(function() {
                  element.addEventListener("click", function(event) {
                      event.preventDefault();
                      if (element.classList.contains("is-selected")) return false;
                      let parent = element.closest(".shopify-section");
                      let currentActiveTab = parent.querySelector(
                          ".predictive-tab-item.is-selected"
                      );
                      let currentActiveProducts = parent.querySelector(".content_active");
                      let selectedTabProducts = parent.querySelector(
                          "." + element.dataset.filter
                      );
                      if (selectedTabProducts) {
                          if (currentActiveTab) {
                              currentActiveTab.classList.remove("is-selected");
                          }
                          if (currentActiveProducts) {
                              currentActiveProducts.classList.remove("content_active");
                              currentActiveProducts.style.display = "none";
                          }
                          element.classList.add("is-selected");
                          selectedTabProducts.classList.add("content_active");
                          selectedTabProducts.style.display = "block";
                      }
                  });
              }, 400);
          });
      }
  }

  function disableNavHover() {
    if (!document.body.classList.contains("nav-cooldown")) {
      document.body.classList.add('nav-cooldown');
    }
  }

  function enableNavHover(instant = false) {
    if (instant) {
      document.body.classList.remove('nav-cooldown');
    } else {
      setTimeout(function() {
        document.body.classList.remove('nav-cooldown');
      }, 2000);
    }
  }

  function hideOtherMegaMenus() {
    Array.from(
      document.querySelectorAll(".joii-custom-details-disclosure")
    ).forEach(function(element) {
        element.removeAttribute("open");
        element.classList.remove("open");
        Array.from(
            element.querySelectorAll(".sub-menu-custom-details-disclosure")
        ).forEach(function(childElement) {
            childElement.removeAttribute("open");
        });
    });
  }


  //console.log("search script ===============");


  function search_drawer(section = document) {
    //console.log("search_drawer check");
    //if (section.__searchDrawerInit) return;
    //section.__searchDrawerInit = true;

    //console.log("search_drawer");

      // if (typeof joiiDesktopSearchResults !== 'undefined' && joiiDesktopSearchResults !== null) {
      //   var joiiDesktopSearchDrawer = joiiDesktopSearchResults.querySelector('#joiiDesktopSearchDrawer');
      //   if (typeof joiiDesktopSearchDrawer !== 'undefined' && joiiDesktopSearchDrawer !== null) {
      //     var mouseLeaveDrawer = joiiDesktopSearchDrawer.querySelector('[data-search-drawer]');
      //     joiiDesktopSearchDrawer.addEventListener("mouseleave", () => {
      //       if (!document.body.classList.contains("nav-cooldown")) {
      //         mouseLeaveDrawer.classList.add("hidden");
      //       }
      //     });
      //   }
      // }


      const searchSelectors = section.querySelectorAll("[data-search-open]");

      // if (!searchSelectors.length) {
      //   console.log("no search selectors yet, retrying...");
      //   setTimeout(() => search_drawer(section), 300);
      //   return;
      // }

      //console.log("search_drawer ready", searchSelectors.length);

      if (searchSelectors) {
          Array.from(searchSelectors).forEach(function(searchSelector) {
              searchSelector.addEventListener("click", (e) => {
                  e.preventDefault();
                  var searchDrawer = document.querySelector(
                      '[data-search-drawer][data-fullwidth="true"]'
                  );
                  let searchParent = searchSelector.closest("[joii-data-search-parent]");
                  //let searchParent = searchSelector.closest(".joiiMobileSearch");
                  //console.log(searchDrawer);
                  //console.log('search drawer ^');
                  if (searchDrawer) {
                      if (searchDrawer.classList.contains("active")) {
                          //searchDrawer.classList.add("hidden");
                          searchDrawer.classList.remove("active");
                          document
                              .querySelector("body")
                              .classList.remove("no-scroll", "search-drawer-open");
                          stopFocusRotation();
                          previousFocusElement.focus();
                          previousFocusElement = "";
                      } else {
                          searchDrawer.classList.add("active");
                          //searchDrawer.classList.remove("hidden");
                          document
                              .querySelector("body")
                              .classList.add("no-scroll", "search-drawer-open");
                          previousFocusElement = searchSelector;
                          focusElementsRotation(searchDrawer);
                          setTimeout(() => {
                              searchDrawer.querySelector("[joii-data-search-input]").focus();
                          }, 100);
                      }
                      __searchResult(
                          (searchDrawer.querySelector("[joii-data-search-input]").value = ""),
                          searchParent
                      );
                  }
              });
              searchSelector.addEventListener("keydown", (e) => {
                  document.querySelector("body").classList.add("tab-focus");
              });
          });
      }
      // search input
      let searchInputElements = section.querySelectorAll("[joii-data-search-input]");
      const headerNavBlocks = document.querySelector('.header-nav-blocks');
      const desktopSearchDrawer = document.getElementById("joiiDesktopSearchDrawer");
      
      Array.from(searchInputElements).forEach(function(searchInput) {
          let searchParent;
          if (searchInput.classList.contains('joiiMobileSearch')) {
            searchParent = searchInput.closest("[joii-data-search-parent]");
            //console.log('searchparenthasmobile');
          } else {
            searchParent = desktopSearchDrawer;
            //console.log('searchparenthasdesktop');
          }
          // searchInput.addEventListener("keyup", (event) => {
          //     console.log("keyup");
          //     event.preventDefault();
          //     clearTimeout(searchTyping);
          //     searchTyping = setTimeout(function() {
          //         if (searchParent) {
          //             let searchTerm = searchInput.value;
          //             __searchResult(searchTerm, searchParent);
          //         }
          //     }, 200);
          // });
          searchInput.addEventListener("keyup", (event) => {
            clearTimeout(searchTyping);

            searchTyping = setTimeout(() => {
              __searchResult(searchInput.value, searchParent);
            }, 200);
          });
          // searchInput.addEventListener("click", (event) => {
          //   let searchDrawer;
          //   if (searchInput.classList.contains('joiiMobileSearch')) {
          //     searchDrawer = document.querySelector("[data-search-drawer]");
          //   } else {
          //     searchDrawer = desktopSearchDrawer.querySelector("[data-search-drawer]");
          //   }
          //   if (searchDrawer) {
          //     searchDrawer.classList.remove("hidden");
          //   }

          //   const popup = searchParent.querySelector('.joii-search-popup');

          //   if (popup) {
          //     popup.style.display = 'block';
          //   }
          // });

          function openSearch() {
            let predictiveWrapper = document.querySelector(".joii-predictive-search");
            if (predictiveWrapper) predictiveWrapper.classList.remove("hidden");
            let predictiveSearchResults = predictiveWrapper.querySelector(".predictive-search-results");
            if (predictiveSearchResults) predictiveSearchResults.classList.remove("hidden");

            hideOtherMegaMenus();

            const popup = document.querySelector('.joii-search-popup');
            if (popup && popup.innerHTML.trim() !== "") {
              popup.style.display = 'grid';
              setSearchPopupOpen(true);
            }
          }

          searchInput.addEventListener("click", () => openSearch(searchInput));
          searchInput.addEventListener("focus", () => openSearch(searchInput));
          searchInput.addEventListener("touchstart", () => openSearch(searchInput), { passive: true });

          // searchInput.addEventListener("click", (event) => {
          //   let predictiveWrapper = document.querySelector(".joii-predictive-search");
          //   if (predictiveWrapper) predictiveWrapper.classList.remove("hidden");
          //   let predictiveSearchResults = predictiveWrapper.querySelector(".predictive-search-results");
          //   if (predictiveSearchResults) predictiveSearchResults.classList.remove("hidden");

          //   hideOtherMegaMenus();

          //   const popup = searchParent.querySelector('.joii-search-popup');
          //   if (popup && popup.innerHTML.trim() !== "") {
          //     popup.style.display = 'grid';
          //     setSearchPopupOpen(true);
          //   }
          // });

          // searchInput.addEventListener("focus", () => {
          //   const popup = searchParent.querySelector('.joii-search-popup');
          //   // only reopen if results already exist
          //   if (popup && popup.innerHTML.trim() !== "") {
          //     popup.style.display = 'grid';
          //     setSearchPopupOpen(true);
          //   }
          // });
          searchInput.addEventListener("search", (event) => {
              event.preventDefault();
              clearTimeout(searchTyping);
              if (searchParent) {
                  __searchResult("", searchParent);
              }
          });
      });

      let searchInputResetBtns = section.querySelectorAll("[data-search-reset]");
      Array.from(searchInputResetBtns).forEach(function(searchInputResetBtn) {
          searchInputResetBtn.addEventListener("click", (event) => {
              event.preventDefault();
              clearTimeout(searchTyping);
              searchInputResetBtn
                  .closest("form")
                  .querySelector("[joii-data-search-input]").value = "";
              setTimeout(function() {
                  searchInputResetBtn
                      .closest("form")
                      .querySelector("[joii-data-search-input]")
                      .focus();
                  __searchResult("");
              }, 300);
          });
      });

      let searchBySpeechs = section.querySelectorAll("[data-speech-search]");
      Array.from(searchBySpeechs).forEach(function(searchBySpeech) {
          initSpeectRecognition(searchBySpeech);
      });
  }


  const params = new URLSearchParams(window.location.search);
  const dym = params.get("dym");
  if (dym) {
    const el = document.querySelector(".joii-dym");
    if (el) {
      el.innerHTML = `Did you mean: <strong>${dym}</strong>?`;
      el.style.display = "block"; // In case it's hidden
      el.classList.remove('hidden');
      el.href = `/search?type=product,collection&q=${encodeURIComponent(dym)}`;
    }
  }
  

  try {
    fuseCategorically = new Fuse(fuseCategories, {
      keys: ['term'],
      includeScore: true,
      threshold: 0.4
    });

    fuseTypos = new Fuse(fuseWords, {
      includeScore: true,
      threshold: 0.4
    });
    //console.log("fuse set");
  } catch (e) {
    console.error("Fuse init failed:", e);
  }
  
  const searchForms = document.querySelectorAll("form.predictive-search");
  if (searchForms.length > 0) {
    // override search form submit
    searchForms.forEach(function (searchForm) {
      searchForm.addEventListener("submit", function (e) {
        e.preventDefault();

        const query = searchForm.querySelector("input[name='q']").value.trim();

        fuseSearch(query);
      });
    });
    //console.log("search forms found");
  } else {
    console.log("no search forms");
  }

  // document.addEventListener('click', function(e) {

  //   const popup = document.querySelector('.joii-search-popup');
  //   const search = document.querySelector('[joii-data-search-input]');

  //   if (!popup || !search) return;

  //   if (
  //     !popup.contains(e.target) &&
  //     !search.contains(e.target)
  //   ) {
  //     popup.style.display = 'none';
  //     setSearchPopupOpen(false);
  //   }

  // });

  // document.addEventListener('click', function (e) {
  //   if (searchJustOpened) return;

  //   const popup = document.querySelector('.joii-search-popup');
  //   const search = document.querySelector('[joii-data-search-input]');

  //   if (!popup || !search) return;

  //   const clickedInsidePopup = popup.contains(e.target);
  //   const clickedSearch = search.contains(e.target);

  //   if (!clickedInsidePopup && !clickedSearch) {
  //     popup.style.display = 'none';
  //     setSearchPopupOpen(false);
  //   }
  // });

  document.addEventListener('pointerdown', function (e) {
    const searchParents = document.querySelectorAll('[joii-data-search-parent]');

    let clickedInsideSearch = false;

    searchParents.forEach(parent => {
      if (parent.contains(e.target)) {
        clickedInsideSearch = true;
      }
    });

    const popup = document.querySelector('.joii-search-popup');

    if (!popup) return;

    if (!clickedInsideSearch && !popup.contains(e.target)) {
      popup.style.display = 'none';
      setSearchPopupOpen(false);
    }
  });

  try {
    search_drawer();
    //console.log("search drawer start");
  } catch (e) {
    console.error("search_drawer failed:", e);
  }
});